import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q10',
  templateUrl: './r-q10.component.html',
  styleUrls: ['./r-q10.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ10Component implements OnInit {

  @Input() data: any;
  hgValue;
  rent_own;
  question;
  isChecked = false;
  showbutton = true;
  questions;
  userResponses = [];
  index;
  questionObj;
  messagetype;
  deviceWidth;
  user_bot = false;
  option1;
  option2;
  rent_src;
  own_src;
  timer;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
    this.hgValue = {
      value1: false,
      value2: false
    };
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 0);
    }
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.option1 = document.getElementById('Rent_mob');
      this.option2 = document.getElementById('Own_mob');
    } else {
      this.option1 = document.getElementById('Rent');
      this.option2 = document.getElementById('Own');
    }
    // check the flow is renewal
    if (this.residentialService.questionFlowType === 'renewal') {
      this.residentialService.messageService({ 'nextId': '0014' });
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }

    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.rent_own = obj.fieldValue;
        if (!_.isEmpty(this.rent_own)) {
          this.isChecked = true;
          if (this.rent_own === 'Rent') {
            this.rent_src = 'assets/images/rent-pink.png';
            this.own_src = 'assets/images/own-gray.png';
            this.hgValue = {
              value1: true,
              value2: false
            };
            this.option1.parentElement.parentElement.classList.add('active-select');
          } else if (this.rent_own === 'Own') {
            this.rent_src = 'assets/images/rent-gray.png';
            this.own_src = 'assets/images/own-pink.png';
            this.hgValue = {
              value1: false,
              value2: true
            };
            this.option2.parentElement.parentElement.classList.add('active-select');
          }
          this.user_bot = true;
          if (this.deviceWidth < 768) {
            this.goNext();
          }
        } else {
          this.rent_src = 'assets/images/rent-gray.png';
          this.own_src = 'assets/images/own-gray.png';
        }
      } else {
        this.rent_src = 'assets/images/rent-gray.png';
        this.own_src = 'assets/images/own-gray.png';
      }
    }
    this.messagetype = this.residentialService.messervicetype;

    if(!this.hgValue.value1 && !this.hgValue.value2)
    {
      this.showbutton = false;
    }
  }

  getValue(event) {
    this.rent_own = event.target.value;
    this.isChecked = event.target.checked;
    if (this.isChecked === true) {
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
      if (this.rent_own === 'Rent') {
        this.rent_src = 'assets/images/rent-pink.png';
        this.own_src = 'assets/images/own-gray.png';
        this.hgValue = {
          value1: true,
          value2: false
        };
        this.option1.parentElement.parentElement.classList.add('active-select');
        if (_.contains(this.option2.parentElement.parentElement.classList, 'active-select')) {
          this.option2.parentElement.parentElement.classList.remove('active-select');
        }
      } else {
        this.rent_src = 'assets/images/rent-gray.png';
        this.own_src = 'assets/images/own-pink.png';
        this.hgValue = {
          value1: false,
          value2: true
        };
        this.option2.parentElement.parentElement.classList.add('active-select');
        if (_.contains(this.option1.parentElement.parentElement.classList, 'active-select')) {
          this.option1.parentElement.parentElement.classList.remove('active-select');
        }
      }
      this.user_bot = true;
      if (this.deviceWidth < 768) {
        this.goNext();
      }
    } else {
      this.rent_src = 'assets/images/rent-gray.png';
      this.own_src = 'assets/images/own-gray.png';
      this.hgValue = {
        value1: false,
        value2: false
      };
      this.rent_own = '';
      if (_.contains(this.option2.parentElement.parentElement.classList, 'active-select')) {
        this.option2.parentElement.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.option1.parentElement.parentElement.classList, 'active-select')) {
        this.option1.parentElement.parentElement.classList.remove('active-select');
      }
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
      this.user_bot = false;
    }
    this.save();

    if (this.isChecked === true)
    {
      if (this.deviceWidth < 768) {
       
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
  
      }

    }
  }

  next() {
    if (_.isEmpty(this.rent_own)) {
      // console.log.log(this.rent_own);
      // alert('Select the Option');
    } else {
      this.residentialService.messageService({ 'currentId': this.data, 'rent_own': this.rent_own });
    }
  }
  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'res_question_id': this.data, 'fieldName': 'rent_own', 'fieldValue': this.rent_own
    };
    this.residentialService.updateResponses(Obj);
  }
}
